var React = require('react');

function IconPageview (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","d":"M0 0H24V24H0z","key":0}),React.createElement("path",{"fill":"#9e9e9e","d":"M13.388 18.25a5.362 5.362 0 0 0 2.868-.831l2.928 2.9 1.7-1.686-2.924-2.889a5.256 5.256 0 0 0 .84-2.838 5.4 5.4 0 1 0-5.412 5.344zm.012-8.312a2.969 2.969 0 1 1-3 2.969 2.986 2.986 0 0 1 3-2.969zM23.6 4H4.4A2.4 2.4 0 0 0 2 6.375v14.25A2.4 2.4 0 0 0 4.4 23h19.2a2.4 2.4 0 0 0 2.4-2.375V6.375A2.4 2.4 0 0 0 23.6 4zm0 16.625H4.4V6.375h19.2z","transform":"translate(-2 -2)","key":1})]);
}

IconPageview.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconPageview;

IconPageview.default = IconPageview;
